import { usePublicLanguage } from "../../context/PublicLanguage";
import React from "react";
import { Link } from "react-router-dom";
import { categoryLabel } from "@/components/CategoryTag";
import { articleLanguage, articlePath } from "../../lib/articleLanguage";
import { timeAgo } from "@/lib/format";

export default function QuickBites({ items = [], isLoading = false, isError = false }) {
  const brief = article => {
    const text = [article.excerpt, article.social_summary, article.the_dish?.summary, article.subheadline]
      .find(value => typeof value === 'string' && value.trim()) || '';
    return text.length > 280 ? text.slice(0, 277).trimEnd() + '…' : text;
  };
  const { t, language } = usePublicLanguage();
  return (
    <div className="rounded-lg border overflow-hidden" style={{ borderColor: "rgba(255,255,255,0.08)", background: "#111315" }}>
      <div className="px-5 py-4 border-b flex items-center gap-2.5" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
        <span className="w-2 h-2 rounded-full td-pulse" style={{ background: "#FF8A1F" }} />
        <span className="font-display font-bold tracking-tight text-white">{t('Quick Bites')}</span>
        <span className="td-eyebrow ml-auto" style={{ color: "#71767c", fontSize: "0.6rem" }}>{t('Breaking')}</span>
      </div>
      <ul className="divide-y" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
        {!items.length && <li className="p-5 text-sm text-[#A7ABB0]" role="status">{t(isLoading ? 'Loading…' : isError ? 'Stories unavailable. Please try again.' : 'No published stories yet.')}</li>}
        {items.slice(0, 5).map((item) => {
          const selected = articleLanguage(item, language);
          const qb = selected.article;
          const inner = (
            <div className="px-5 py-4 hover:bg-[#1B1E21] transition-colors group" style={{ borderLeft: "2px solid transparent" }}>
              <div className="flex items-center gap-2 mb-1.5 td-eyebrow" style={{ fontSize: "0.58rem" }}>
                <span style={{ color: "#FF8A1F" }}>{categoryLabel(qb.category, language)}</span>
                <span className="opacity-30 text-white">/</span>
                <span style={{ color: "#71767c" }}>{timeAgo(qb.published_at, language)}</span>
              </div>
              <h4 lang={selected.language} className="font-display font-semibold text-white leading-snug text-[0.98rem] group-hover:text-[#FF8A1F] transition-colors">
                {qb.headline}
              </h4>
              <p lang={selected.language} className="mt-1 text-[#A7ABB0] leading-snug line-clamp-3" style={{ fontSize: "0.86rem" }}>
                {brief(qb)}
              </p>
            </div>
          );
          return (
            <li key={qb.slug} data-testid={`quick-bite-${qb.id}`}>
              <Link to={articlePath(qb, selected.language)}>{inner}</Link>
              {language === 'id' && selected.language === 'en' && <p className="px-5 pb-3 text-xs text-[#FFB347]">English · Terjemahan belum tersedia</p>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
